import { apolloClient } from '~/apollo-client';
import { Flex_FetchIsInLmiZoneQuery, Flex_FetchIsInLmiZoneQueryVariables } from '~/typings/graphql';
import { FETCH_IS_IN_LMI_ZONE } from './fetch-is-in-lmi-zone.queries';

export type FetchIsInLmiZoneParams = {
  utilityAccountId: number;
};

export type FetchIsInLmiZoneResponse = {
  lmiZoneOptions: {
    isInLmiArea: boolean;
    isInCensusTract: boolean;
    error: boolean;
  };
};

export const fetchIsInLmiZone = async (
  params: FetchIsInLmiZoneParams,
): Promise<FetchIsInLmiZoneResponse> => {
  const { data } = await apolloClient.query<
    Flex_FetchIsInLmiZoneQuery,
    Flex_FetchIsInLmiZoneQueryVariables
  >({
    query: FETCH_IS_IN_LMI_ZONE,
    variables: {
      utilityAccountId: params.utilityAccountId,
    },
    fetchPolicy: 'no-cache',
  });

  return {
    lmiZoneOptions: data.utilityAccount.lmiZoneOptions!,
  };
};
